import React from 'react';
import { toast } from "react-toastify";

export default function CopyIcon({text}) {
    function handleClipbord(id) {
        navigator.clipboard.writeText(id).then(() => toast.success("copied"));
    }

    if(!text) return <></>

    return (<>
        &nbsp;
        <i
            className={`far fa-clipboard hidden group-hover:inline`}
            style={{
            cursor: "pointer",
            color: "rgb(9, 28, 170)",
            }}
            onClick={() => handleClipbord(text)}
        />
        </>
    )
}